import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-qr-popup',
  templateUrl: './qr-popup.component.html',
  styleUrls: ['./qr-popup.component.scss']
})
export class QrPopupComponent {

  @ViewChild('qrcodeElement', { static: false }) qrcodeElement!: ElementRef;
  link: any;

  constructor(
    private toast:ToastrService,
    public dialogRef: MatDialogRef<QrPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.link = data?.url;
  }

  ngOnInit(): void { }

  downloadQRCode() {
    const qrElement = this.qrcodeElement.nativeElement.querySelector('canvas');
    if (qrElement) {
      const imgData = qrElement.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = imgData;
      a.download = 'qr-code.png';
      a.click();
      this.toast.success('QR Code Downloaded Successfully')
    } else {
      console.warn('Canvas element not found — make sure renderAs="canvas" is set');
    }
  }

  close() {
    this.dialogRef.close();
  }

}
